<h2 mat-dialog-title class="text-center" *ngIf="hideButtonAdd">Thêm mới Tỉnh/Thành phố</h2>
<h2 mat-dialog-title class="text-center" *ngIf="!hideButtonAdd">Chỉnh sửa thông tin</h2>
<form [formGroup]="dataAdministrative" class="form" (ngSubmit)="onClickSubmit(dataAdministrative.value);" enctype="multipart/form-data">
    <mat-dialog-content class="mat-typography">
        <div class="title-dialog-center-global">
            <div class="avatar-custom">
                <div class="img-module" (click)="uploadImage()">
                    <img [src]="urlImage ? urlImage : 'https://increasify.com.au/wp-content/uploads/2016/08/default-image.png'" class="avatar">
                    <div class="box-image">
                        <label><mat-icon >photo library</mat-icon>
                            <span>Thêm ảnh </span></label>
                    </div>
                    <input type="file" class="avatar-file" name="avatar" style="display: none;" id="inputUploadFile" (change)="onFileChange($event)">
                </div>

            </div>
        </div>
        <!-- <form> -->
        <div class="row custom-space-right">
            <div class="form-group col-md-6 row row-global">
                <label class="col-md-3">Tên Tỉnh/Thành phố</label>
                <div class="col-md-8 pl-0 pr-0">
                    <input formControlName="fullname" type="text" class="form-control input-field-global" placeholder="Nhập tên tỉnh/thành phố">
                    <mat-error *ngFor="let validation of education_validation_messages.fullname">
                        <p class="error-message" *ngIf="dataAdministrative.get('fullname').hasError(validation.type) && (dataAdministrative.get('fullname').dirty || dataAdministrative.get('fullname').touched)">{{validation.message}}</p>
                    </mat-error>
                </div>
            </div>
            <div class="form-group col-md-6 row row-global">
                <label class="col-md-3 offset-1">Mã</label>
                <div class="col-md-8 pl-0 pr-0">
                    <input formControlName="code" [readOnly]="true" type="text" class="form-control input-field-global" placeholder="Nhập mã">
                    <mat-error *ngFor="let validation of education_validation_messages.code">
                        <p class="error-message" *ngIf="dataAdministrative.get('code').hasError(validation.type) && (dataAdministrative.get('code').dirty || dataAdministrative.get('code').touched)">{{validation.message}}</p>
                    </mat-error>
                </div>
            </div>
        </div>

        <div class="row custom-space-right">
            <div class="form-group col-md-6 row row-global">
                <label class="col-md-3">Thứ tự sắp xếp</label>
                <div class="col-md-8 pl-0 pr-0">
                    <input formControlName="order" onlyNumber (keypress)="numberOnly($event)" type="number" min="1" class="form-control input-field-global" placeholder="Nhập thứ tự sắp xếp">
                    <mat-error *ngFor="let validation of education_validation_messages.order">
                        <p class="error-message" *ngIf="dataAdministrative.get('order').hasError(validation.type) && (dataAdministrative.get('order').dirty || dataAdministrative.get('order').touched)">{{validation.message}}</p>
                    </mat-error>
                </div>
            </div>
            <div class="form-group col-md-6 row row-global">
                <label class="col-md-3 offset-1">Trạng thái</label>
                <div class="col-md-8 pl-0 pr-0">
                    <mat-checkbox formControlName="status">Kích hoạt</mat-checkbox>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-button mat-dialog-close mat-raised-button (click)="cancelDialog();">Cancel</button>
        <button mat-button type="submit" mat-raised-button color="primary" *ngIf="hideButtonAdd" [disabled]="!dataAdministrative.valid">Add</button>
        <button mat-button type="submit" mat-raised-button color="primary" *ngIf="!hideButtonAdd" [disabled]="!dataAdministrative.valid">Update</button>
    </mat-dialog-actions>
</form>